import { addClassNamesToElement } from '@lexical/utils'
import {
  $applyNodeReplacement,
  DecoratorNode,
  EditorConfig,
  LexicalEditor,
  LexicalNode,
  NodeKey
} from 'lexical'

import { TableController } from '../../ui/TableController'

import { SerializedTableControllerNode } from './interface'

export class TableControllerNode extends DecoratorNode<React.JSX.Element> {
  constructor(key?: NodeKey) {
    super(key)
  }

  static getType(): string {
    return 'tablecontroller'
  }

  static clone(node: TableControllerNode) {
    return new TableControllerNode(node.getKey())
  }

  static importJSON(
    serializedNode: SerializedTableControllerNode
  ): TableControllerNode {
    return $createTableControllerNode()
  }

  exportJSON(): SerializedTableControllerNode {
    return {
      ...super.exportJSON(),
      type: TableControllerNode.getType()
    }
  }

  isIsolated(): boolean {
    return true
  }

  isInline(): boolean {
    return false
  }

  isKeyboardSelectable(): boolean {
    return false
  }

  createDOM(config: EditorConfig, _editor: LexicalEditor): HTMLElement {
    const dom = document.createElement('div')
    addClassNamesToElement(dom, config.theme.tableController)
    return dom
  }

  updateDOM(
    _prevNode: unknown,
    _dom: HTMLElement,
    _config: EditorConfig
  ): boolean {
    return false
  }

  decorate(editor: any, config: any): React.JSX.Element {
    return <TableController tableControllerNodeKey={this.getKey()} />
  }
}

export const $createTableControllerNode = () => {
  return $applyNodeReplacement(new TableControllerNode())
}

export const $isTableControllerNode = (
  node: LexicalNode | null
): node is TableControllerNode => {
  return node instanceof TableControllerNode
}
